import React from 'react'
import Header from "../components/layout/Header"
import Handbook from "../components/blocks/Handbook"
import Brigades from "../components/blocks/Handbook/components/Brigades"
import Employees from "../components/blocks/Handbook/components/Employees"
import classes from "../components/layout/Layout/Layout.module.scss"

export default function EmployeesPage() {

  const blocks = [
    {
      title: "Сотрудники",
      block: <Employees/>
    },
    {
      title: "Бригады",
      block: <Brigades/>
    }
  ]

  return (
    <>
      <div className={classes.header}>
        <Header title={'Сотрудники'} showUser={true}/>
      </div>
      <div className={classes.content}>
        <Handbook blocks={blocks}/>
      </div>
    </>
  )
}